import compact from 'lodash/compact'
import { DisplayMode } from 'modules/water/api/types'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { selectedDeadShrimpIdState } from '../stores/atom'
import { useGetDeadShrimps } from './queries'

export const useDeadShrimps = (mode: DisplayMode) => {
  const { data, ...rest } = useGetDeadShrimps(mode)

  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.shrimps).flat()),
    }),

    [data, mode]
  )
}

export const useFindDeadShrimpById = () => {
  const id = useRecoilValue(selectedDeadShrimpIdState)
  const { data } = useDeadShrimps('table')
  return useMemo(() => data.find((el) => el.id === id), [data, id])
}
